import { render, staticRenderFns } from "./Troubleshoot.vue?vue&type=template&id=05f9a87f&scoped=true&"
import script from "./Troubleshoot.vue?vue&type=script&lang=js&"
export * from "./Troubleshoot.vue?vue&type=script&lang=js&"
import style0 from "./Troubleshoot.vue?vue&type=style&index=0&id=05f9a87f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f9a87f",
  null
  
)

export default component.exports